import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import cn from 'classnames';

class ButtonArrowed extends PureComponent {
  render() {
    const {
      link,
      className,
      direction,
      children,
      ...props
    } = this.props;

    if (!!link) {
      const LinkComponent = this.props.download ?
        (props) => <a {...props} /> : // eslint-disable-line jsx-a11y/anchor-has-content
        Link;

      return (
        <LinkComponent to={link} className={cn('btn btn-arrowed', className)} {...props}>
          {(direction === 'left') &&
            <span className="icon">←</span>
          }

          <span>{children}</span>

          {(direction === 'right') &&
            <span className="icon">→</span>
          }
        </LinkComponent>
      );
    }

    return (
      <button className={cn('btn btn-arrowed', className)} {...props}>
        {(direction === 'left') &&
          <span className="icon">←</span>
        }

        <span>{children}</span>

        {(direction === 'right') &&
          <span className="icon">→</span>
        }
      </button>
    );
  }
}

ButtonArrowed.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf(['left', 'right']),
  children: PropTypes.any,
  link: PropTypes.string
};

export default ButtonArrowed;



// WEBPACK FOOTER //
// ./src/components/widgets/Buttons/ButtonArrowed.js